// src/components/TopNav/TopNav.js
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './TopNav.module.css';

function TopNav() {
  // Array of link objects
  let navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/schedule', label: 'Schedule' },
    { path: '/contact', label: 'Contact' }
  ];

  const [serviceArea, setServiceArea] = useState('');
  const [hours, setHours] = useState('');
  const [navHome, setNavHome] = useState('');
  const [navServices, setNavServices] = useState('');
  const [navSchedule, setNavSchedule] = useState('');
  const [navContact, setNavContact] = useState('');

  useEffect(() => {
    // Hours/Service ARea
    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=service-area')
      .then(response => response.json())
      .then(data => {
        if (data[0]?.content?.rendered) {
          setServiceArea(data[0].content.rendered);
        }
      })
      .catch(error => console.error('Error fetching header service area content:', error));

    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=hours')
      .then(response => response.json())
      .then(data => {
        if (data[0]?.content?.rendered) {
          setHours(data[0].content.rendered);
          navLinks[0].label = data[0].content.rendered;
        }
      })
      .catch(error => console.error('Error fetching header hours content:', error));

    // Top Nav Links
    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-home')
    .then(response => response.json())
    .then(data => {
      if (data[0]?.content?.rendered) {
        setNavHome(data[0].content.rendered);
      }
    })
    .catch(error => console.error('Error fetching Nav Item Home content:', error));

    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-services')
    .then(response => response.json())
    .then(data => {
      if (data[0]?.content?.rendered) {
        setNavServices(data[0].content.rendered);
      }
    })
    .catch(error => console.error('Error fetching Nav Item Services content:', error));

    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-schedule')
    .then(response => response.json())
    .then(data => {
      if (data[0]?.content?.rendered) {
        setNavSchedule(data[0].content.rendered);
      }
    })
    .catch(error => console.error('Error fetching Nav Item Schedule content:', error));

    fetch(process.env.REACT_APP_WP_SERVER + '/wp-json/wp/v2/site_header?slug=nav-item-contact')
    .then(response => response.json())
    .then(data => {
      if (data[0]?.content?.rendered) {
        setNavContact(data[0].content.rendered);
      }
    })
    .catch(error => console.error('Error fetching Nav Item Contact content:', error));
  });

  return (
    <header className={styles.header}>
      <div id={styles["header_container"]}>
        <div id={styles["logo"]}>
          <div>
            <h1><img src="https://admin.onepawinfrontoftheother.org/wp-content/uploads/2025/01/paw_pink2.png" alt="One Paw In Front Of The Other" />ne Paw</h1><h2>In Front Of The Other</h2>
          </div>
        </div>
        <nav className={styles.nav}>
          <NavLink
            to='/'
            className={({ isActive }) => (isActive ? styles.active : '')}
            dangerouslySetInnerHTML={{ __html: navHome }}
          ></NavLink>
          <NavLink
            to='/#services'
            dangerouslySetInnerHTML={{ __html: navServices }}
            onClick={(e) => {
              e.preventDefault(); // Prevents default behavior of reloading
              const section = document.getElementById("services");
              if (section) {
                section.scrollIntoView({ behavior: "smooth" }); // Smooth scrolling
              }}}
          ></NavLink>
          <NavLink
            to='/schedule'
            className={({ isActive }) => (isActive ? styles.active : '')}
            dangerouslySetInnerHTML={{ __html: navSchedule }}
          ></NavLink>
          <NavLink
            to='/contact'
            className={({ isActive }) => (isActive ? styles.active : '')}
            dangerouslySetInnerHTML={{ __html: navContact }}
          ></NavLink>
        </nav>
        <div id={styles["ops"]}>
          <div id={styles["location"]} dangerouslySetInnerHTML={{ __html: serviceArea }}></div>
          <div id={styles["hours"]} dangerouslySetInnerHTML={{ __html: hours }}></div>
        </div>
      </div>
    </header>
  );
}

export default TopNav;
